import { render } from "./Evmobility.vue?vue&type=template&id=23856bdc&scoped=true"
import script from "./Evmobility.vue?vue&type=script&lang=js"
export * from "./Evmobility.vue?vue&type=script&lang=js"

import "./Evmobility.vue?vue&type=style&index=0&id=23856bdc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-23856bdc"

export default script